/* eslint-disable */
import Vue, { PluginObject } from 'vue'
import { getKeys } from '~/lib/utils/utils'

const importComponents = (context:__WebpackModuleApi.RequireContext) => {
  return context.keys().reduce((acc, key) => {
    const componentName = key.replace(/^.*[\\/]/, '').split('.')[0]
    acc[componentName] = context(key).default
    return acc
  }, {} as {[key: string]: Utils.Object})
}

const components = importComponents(require.context('~/assets/icons/', true, /\.svg$/))

// Install the above defined components
const icons: PluginObject<Vue> = {
  install (Vue) {
    getKeys(components).forEach((componentName) => {
      if (typeof componentName !== 'string') { return }
      Vue.component(componentName, components[componentName])
    })
  }
}

Vue.use(icons)
